module.exports = __webpack_public_path__ + "static/media/oxford.58374a2a.jpeg";